<template>
    <default-view
        v-if="viewMode === FilterViewMode.Default"
        v-bind="allProps"
        @navigate-to-collection="navigateToCollection($event)"
    ></default-view>
    <multiple-checkboxes-view
        v-else-if="viewMode === FilterViewMode.MultipleCheckboxes"
        v-bind="allProps"
        @update-product-count="emit('update-product-count')"
        @navigate-to-collection="navigateToCollection($event)"
        @emit-value="emitValue($event)"
    ></multiple-checkboxes-view>
    <div data-error="unknown-view-mode" v-else></div>
</template>

<script setup lang="ts">
import { type PropType, computed } from "vue";
import { getCollectionUrl as getColUrl } from "./collection-url";
import defaultView from "./view-modes/default/list.vue";
import multipleCheckboxesView from "./view-modes/multiple-checkboxes/list.vue";
import {
    type MappedProductCollectionModel,
    type ProductCollectionModel,
} from "./models";
import { makeGroupedValue } from "./value";
import { FilterViewMode } from "./view-modes/types";
//import { flattenAllCollections } from "./collection-methods";
const props = defineProps({
    filler: {
        type: Boolean,
        default: false,
    },
    viewMode: {
        type: Number as PropType<FilterViewMode>,
        required: true,
    },
    siteGuid: Number,
    productListGuid: Number,
    value: Array as PropType<number[][]>,
    root: {
        type: Array as PropType<MappedProductCollectionModel[]>,
        required: true,
    },
    scopedRoot: Object as PropType<MappedProductCollectionModel>,
    baseUrl: {
        type: String,
    },
    getVisible: {
        type: Function,
        required: true,
    },
    matchedLogicalName: String,
    matchedLogicalNameEntityGuid: Number,
    matchedLogicalNameModuleGuid: Number,
    matchedLogicalNameSubModuleGuid: Number,
    forceBackArrow: Boolean,
});

const allProps = computed(() => {
    return {
        viewMode: props.viewMode,
        siteGuid: props.siteGuid,
        //collectionId: props.collectionId,
        productListGuid: props.productListGuid,
        value: props.value,
        root: props.root,
        scopedRoot: props.scopedRoot,
        baseUrl: props.baseUrl,
        getVisible: props.getVisible,
        //makeGroupedValue: props.makeGroupedValue,
        getCollectionUrl: getCollectionUrl,
        //findCollectionById: findCollectionById,
        //getFlattenedCollections: getFlattenedCollections,
        forceBackArrow: props.forceBackArrow,
        matchedLogicalName: props.matchedLogicalName,
        matchedLogicalNameEntityGuid: props.matchedLogicalNameEntityGuid,
        matchedLogicalNameModuleGuid: props.matchedLogicalNameModuleGuid,
        matchedLogicalNameSubModuleGuid: props.matchedLogicalNameSubModuleGuid,
    };
});
function getCollectionUrl(item: MappedProductCollectionModel) {
    return getColUrl(
        item,
        props.viewMode,
        props.baseUrl,
        props.value,
        props.root,
        props.matchedLogicalName,
        props.matchedLogicalNameEntityGuid,
        props.matchedLogicalNameModuleGuid,
        props.matchedLogicalNameSubModuleGuid
    );
}
// function findCollectionById(
//     collectionId: number,
//     mappedRoot: ProductCollectionModel[] | MappedProductCollectionModel[] | undefined
// ) {
//     for (const collection of flattenAllCollections(mappedRoot)) {
//         if (collection.Id == collectionId) return collection;
//     }
//     return undefined;
// }
// function* getFlattenedCollections(
//     collections: ProductCollectionModel[]
// ): Generator<ProductCollectionModel> {
//     if (collections != null) {
//         for (const collection of collections) {
//             yield collection;
//             for (const subCollection of getFlattenedCollections(
//                 collection.SubCollections
//             )) {
//                 yield subCollection;
//             }
//         }
//     }
// }

function navigateToCollection(
    item:
        | {
              collection: ProductCollectionModel;
              scopedRoot: ProductCollectionModel | undefined;
          }
        | ProductCollectionModel
        | undefined
        | null
) {
    if (item == null) {
        emitValue(null);
    } else {
        const col = "collection" in item ? item.collection : item;
        const val = makeGroupedValue(
            col.Id,
            undefined,
            props.viewMode,
            props.root
        );

        emitValue(
            val.value,
            "scopedRoot" in item ? item.scopedRoot : undefined
        );
    }
}

const emit = defineEmits(["input", "update-product-count"]);

function emitValue(
    value: number[][] | null | undefined,
    scopedRoot?: ProductCollectionModel | undefined
) {
    emit("input", { value, scopedRoot });
}
// function fullPath(dir) {
//     const parts = Array.from(navDown(dir)).map((x) => x.name);
//     return parts.join(" / ");
// }
// function* navDown(dir) {
//     const reversed = Array.from(navUp(dir)).reverse();
//     for (const item of reversed) yield item;
// }
// function* navUp(dir) {
//     yield dir;
//     if (dir.parent != null) {
//         for (const parent of navUp(dir.parent)) yield parent;
//     }
// }
</script>
